import React from 'react';
import * as Sentry from '@sentry/react';

interface AppErrorBoundaryState {
  hasError: boolean;
}

interface AppErrorBoundaryProps {
  children: React.ReactNode;
}

class AppErrorBoundary extends React.Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  state: AppErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    Sentry.withScope((scope) => {
      scope.setTag('stage', 'react_error_boundary');
      scope.setContext('react', { componentStack: errorInfo.componentStack });
      Sentry.captureException(error);
    });
  }

  handleReload = (): void => {
    window.location.reload();
  };

  render(): React.ReactNode {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <main
        className="App"
        role="alert"
        style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24 }}
      >
        <section style={{ maxWidth: 520, textAlign: 'center' }}>
          <h1 style={{ fontSize: 24, marginBottom: 12 }}>Interview session needs to reload</h1>
          <p style={{ marginBottom: 20 }}>
            Something interrupted the page rendering. Reloading will reconnect you to the interview.
          </p>
          <button type="button" onClick={this.handleReload}>
            Reload interview
          </button>
        </section>
      </main>
    );
  }
}

export default AppErrorBoundary;
